import {ReactNode} from 'react'

export const ServiceRequestHeader = ({children}: { children: ReactNode }) => {
    return <div className="service-request-form-header">
        {children}
    </div>
}